import React from 'react';
import { Ban } from 'lucide-react';
import { C } from './shared';
import { QuestionField } from './QuestionField';

export const ModuleBlock = ({ m, answers, confirmed, setAnswer, confirm, change }) => {
  const visible = m.questions.filter(q => q.visible);
  if (!visible.length) return null;
  return (
    <div className="mt-3" data-testid={`rq-module-${m.name.replace(/[^a-z]+/gi, '-').toLowerCase()}`}>
      <p className="text-[10px] font-semibold uppercase tracking-wider flex items-center justify-between" style={{ color: C.blue }}>
        <span>{m.name}</span>
        {m.questions[0].knockout && <span className="normal-case flex items-center gap-1 font-semibold" style={{ color: m.questions[0].knockout.action === 'decline' ? C.red : C.amber }} data-testid={`rq-module-knockout-${m.questions[0].knockout.id}`}><Ban className="w-3 h-3" /> {m.questions[0].knockout.action}: {m.questions[0].knockout.reason}</span>}
      </p>
      {visible.map(q => (
        <QuestionField key={q.id} q={q} answer={answers[q.id]} confirmed={confirmed[q.id]}
          onAnswer={v => setAnswer(q.id, v)} onConfirm={() => confirm(q.id)} onChangePrefill={() => change(q.id)} />
      ))}
    </div>
  );
};
